export function setInterests(interests, userId) {
  return {
    endpoint: `users/${userId}/interests`,
    method: 'POST',
    data: interests,
    requireAuth: true,
    convertApiErrorsToReduxFormErrors: true,
  };
}



// WEBPACK FOOTER //
// ./src/api/config/interests.js